import useComponentSelectorColumnWidth from 'elements/hardwareSelectorV2/useComponentSelectorColumnWidth'
import { Grid } from 'opensolar-ui'
import { useTranslate } from 'react-admin'
import type { OpenSolarThemeType } from 'Themes'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const useStyles = makeOpenSolarStyles((theme: OpenSolarThemeType) => ({
  header: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    // this padding is commented out since accordion functionality removed for phase 1
    // 60px for padding right accounts for placement of accordion dropdown
    // padding: '10px 60px 10px 10px',
    padding: '10px',
  },
  overflowItem: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}))

type HeaderPropsType = {}

const InverterAutoListHeader = (props: HeaderPropsType) => {
  const classes = useStyles()
  const translate = useTranslate()
  const inverterWizardColumnWidth = useComponentSelectorColumnWidth('inverterWizard')

  return (
    <Grid container alignItems="center" xs={12} className={classes.header}>
      <Grid item xs={inverterWizardColumnWidth.item} style={{ paddingLeft: 20 }}>
        {translate('Item')}
      </Grid>
      <Grid item xs={inverterWizardColumnWidth.brand} className={classes.overflowItem}>
        {translate('Brand')}
      </Grid>
      <Grid item xs={inverterWizardColumnWidth.name} className={classes.overflowItem}>
        {translate('Name')}
      </Grid>
      <Grid item xs={inverterWizardColumnWidth.qty}>
        {translate('Quantity Needed')}
      </Grid>
      <Grid item xs={inverterWizardColumnWidth.rating}>
        {translate('Combined Rating')}
      </Grid>
      {inverterWizardColumnWidth.source && (
        <Grid item xs={inverterWizardColumnWidth.source} className={classes.overflowItem}>
          {translate('Select Source')}
        </Grid>
      )}
      {inverterWizardColumnWidth.stock && (
        <Grid item xs={inverterWizardColumnWidth.stock}>
          {translate('Stock')}
        </Grid>
      )}
      {inverterWizardColumnWidth.price && (
        <Grid item xs={inverterWizardColumnWidth.price} className={classes.overflowItem}>
          {translate('Total Price')}
        </Grid>
      )}
      <Grid item xs={inverterWizardColumnWidth.action}></Grid>
    </Grid>
  )
}

export default InverterAutoListHeader
